import React from 'react';
import { Checkbox } from 'antd';
import { localSDK as client } from '../../../../sdk';

type Props = {
    master: string;
    operationalStatus: 'OPEN' | 'CLOSED';
    onUpdated?: (status: 'OPEN' | 'CLOSED') => void;
};

const ConsolidationOperationalStatusCell = ({ master, operationalStatus, onUpdated }: Props) => {
    const [loading, setLoading] = React.useState(false);
    const isClosed = operationalStatus === 'CLOSED';

    return (
        <div onClick={(e) => e.stopPropagation()} title={isClosed ? 'Operationally closed' : 'Operationally open'}>
            <Checkbox
                checked={isClosed}
                disabled={loading}
                onChange={(e) => {
                    const next = e.target.checked ? 'CLOSED' : 'OPEN';
                    setLoading(true);
                    void client
                        .consolidations()
                        .updateMetadata(master, { operationalStatus: next })
                        .then(() => onUpdated?.(next))
                        .finally(() => setLoading(false));
                }}
            >
                {isClosed ? 'Closed' : 'Open'}
            </Checkbox>
        </div>
    );
};

export default ConsolidationOperationalStatusCell;
